import { render, staticRenderFns } from "./comp_LoginForms.vue?vue&type=template&id=d02b64ac"
import script from "./comp_LoginForms.vue?vue&type=script&lang=js"
export * from "./comp_LoginForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports